module.exports = __webpack_public_path__ + "static/img/logo.b4d56497.svg";